(function () {

  'use strict';

  angular.module('SoftwareDistribution')

    .controller('SoftwareDistributionController', function (
      $filter, $http, $location, $log, $rootScope, $scope, $timeout, EventHandlerService, currentTenant,
      SoftwareService, ApplicationType, CpuArchitecture, FileType, OperatingSystem, PrintixVersion, UpdateStrategy) {

      $scope.ApplicationType = ApplicationType;
      $scope.OperatingSystem = OperatingSystem;
      $scope.CpuArchitecture = CpuArchitecture;
      $scope.FileType = FileType;

      $scope.isPrintixEnabled = false;
      $scope.isPowerPDFEnabled = false;
      $scope.helpCaption = 'HelpSoftwarePage';
      $scope.showKioskIdButton = false;
      $scope.showMsiArgumentsButton = false;
      $scope.showPowerPdfArgumentsButton = false;
      $scope.downloadButton = {
        clientWinX64Exe: {
          show: false,
          url: null
        },
        clientWinX64Msi: {
          show: false,
          url: null
        },
        clientWinArm64Exe: {
          show: false,
          url: null
        },
        clientWinArm64Msi: {
          show: false,
          url: null
        },
        clientMacDmg: {
          show: false,
          url: null
        },
        configuratorWinX64: {
          show: false,
          url: null
        },
        configuratorWinArm64: {
          show: false,
          url: null
        },
        redirectorWinX64: {
          show: false,
          url: null
        },
        redirectorWinArm64: {
          show: false,
          url: null
        },
        powerPdfWin: {
          show: false,
          url: null
        },
        powerPdfMac: {
          show: false,
          url: null
        }
      };
      $scope.canon = null;
      $scope.kyocera = null;
      $scope.lexmark = null;
      $scope.lexmarkCapture = null;
      $scope.ricoh = null;
      $scope.ricohInstaller = null;
      $scope.powerbi = null;

      $scope.$watch(function () {
        return $rootScope.currentUser;
      }, function () {
        if ($rootScope.currentUser) {
          $scope.me = $rootScope.currentUser;
        }
      });

      $scope.isCaptionTranslated = function (caption) {
        return caption !== $filter('translate')(caption);
      };

      $scope.openContextMenu = function (event, context, menuOption) {
        $timeout(function () {
          $scope.selectedContextMenuItem = menuOption;
          $scope.contextPosition = { left: event.clientX, top: event.clientY };
          $scope.context = context;
          $scope.resource = currentTenant;
        });
      };

      $scope.closeAllMenues = function () {
        $scope.selectedContextMenuItem = null;
        $scope.contextPosition = null;
        $scope.context = null;
      };

      $scope.openDownloadDesktopApplicationDialog = function (applicationType, operatingSystem, cpuArchitecture, fileType) {
        const application = $scope.softwareVersions.applications
          .find(application => application.appType === applicationType && application.os === operatingSystem);

        if (!application) {
          $log.error(`No application found for type ${applicationType} and OS ${operatingSystem}`);
          return;
        }

        const availableVersions = angular.copy(application.availableVersions || []);
        let specificVersion = application.specificVersion;
        if (specificVersion) {
          const foundSpecificVersion = availableVersions.find(availableVersion => availableVersion.version === specificVersion.version);
          if (!foundSpecificVersion) {
            specificVersion = angular.copy(specificVersion);
            specificVersion.obsolete = true;
            availableVersions.push(specificVersion);
          }
        }

        const downloadableVersions = availableVersions
          .filter(availableVersion => availableVersion.files.some(file => (!cpuArchitecture || file.cpuArch === cpuArchitecture) && file.type === fileType))
          .sort((first, second) => new PrintixVersion(second.version).compareTo(new PrintixVersion(first.version)))
          .map(availableVersion => {
            return {
              version: availableVersion.version,
              obsolete: availableVersion.obsolete,
              downloadUrl: SoftwareService.buildDesktopApplicationDownloadUrl(applicationType, operatingSystem, cpuArchitecture, fileType, availableVersion.version)
            };
          });

        let currentVersion;
        switch ($scope.softwareVersions.updateStrategy) {
          case UpdateStrategy.ADVANCE:
            currentVersion = application.advanceVersion;
            break;
          case UpdateStrategy.GENERAL:
            currentVersion = application.generalVersion;
            break;
          case UpdateStrategy.SPECIFIC:
            currentVersion = application.specificVersion.version;
            break;
        }

        $scope.applicationVersionData = {
          applicationType,
          operatingSystem,
          cpuArchitecture,
          fileType,
          availableVersions: downloadableVersions,
          currentVersion,
          advanceVersion: application.advanceVersion,
          generalVersion: application.generalVersion,
          customVersion: application.customVersion
        };

        $scope.isDownloadDesktopApplicationDialogVisible = true;
      };

      $scope.closeDownloadDesktopApplicationDialog = function () {
        $scope.isDownloadDesktopApplicationDialogVisible = false;
      };

      (function () {
        EventHandlerService.deRegisterListeners();
        $scope.isPrintixEnabled = currentTenant.isPrintixEnabled();
        $scope.isPowerPDFEnabled = currentTenant.isPowerPDFEnabled();
        isolateTenantID();
        getSoftwareLinks();
        loadSoftwareVersions();
      })();

      function isolateTenantID() {
        let tenantID = currentTenant.info._links.self.href.split('/');
        $scope.tenantID = tenantID = tenantID[tenantID.length - 1];
        const dataCenter = getDataCenter();
        $scope.wrapper1 = `WRAPPED_ARGUMENTS=/id:${tenantID}${dataCenter}`;
        $scope.wrapper2 = `WRAPPED_ARGUMENTS=/id:${tenantID}${dataCenter}:oms`;
        $scope.msiArgs = { tenantId: tenantID, wrapper1: $scope.wrapper1, wrapper2: $scope.wrapper2 };
      }

      function getDataCenter() {
        const url = $location.absUrl();
        if (!url.includes('/admin')) {
          $log.error('URL does not include /admin');
          return '';
        }
        const domain = url.split('/admin')[0].split('.');
        const dataCenter = domain[domain.length - 3];
        return dataCenter === 'us' ? ':dc:us' : '';
      }

      function getSoftwareLinks() {
        $http.get(currentTenant.info._links['px:software'].href)
          .then(function (response) {
            $scope.softwareResources = response.data._embedded['px:softwareResources'];
            setupDownloadLinks();
            setCanon();
            setKyocera();
            setLexmark();
            setRicoh();
            setWinDeviceInstallerCli();
            setPowerBi();
            classifyCaptureConnectorFiles();
          })
          .catch(function () {
          });
      }

      function setupDownloadLinks() {
        $scope.softwareResources.forEach(software => {
          software.files.forEach(file => {
            enableDownloadButton(software.appl, software.os, file.type, file.cpuArch, file.path);
          });
        });
        mapSoftwareResources();
      }

      function enableDownloadButton(appl, os, type, cpuArch, url) {
        if (cpuArch == null) {
          cpuArch = 'x64';
        }
        const complextString = appl + '-' + os + '-' + type + '-' + cpuArch;
        switch (complextString) {
          case 'CONFIGURATOR-WIN-EXE-x64':
            $scope.downloadButton.configuratorWinX64.url = url;
            $scope.downloadButton.configuratorWinX64.show = true;
            break;
          case 'CONFIGURATOR-WIN-EXE-arm64':
            $scope.downloadButton.configuratorWinArm64.url = url;
            $scope.downloadButton.configuratorWinArm64.show = true;
            break;
          case 'CLIENT-WIN-EXE-x64':
            $scope.downloadButton.clientWinX64Exe.url = url;
            $scope.downloadButton.clientWinX64Exe.show = true;
            $scope.showKioskIdButton = true;
            break;
          case 'CLIENT-WIN-EXE-arm64':
            $scope.downloadButton.clientWinArm64Exe.url = url;
            $scope.downloadButton.clientWinArm64Exe.show = true;
            $scope.showKioskIdButton = true;
            break;
          case 'CLIENT-WIN-MSI-x64':
            $scope.downloadButton.clientWinX64Msi.url = url;
            $scope.downloadButton.clientWinX64Msi.show = true;
            $scope.showKioskIdButton = true;
            $scope.showMsiArgumentsButton = true;
            break;
          case 'CLIENT-WIN-MSI-arm64':
            $scope.downloadButton.clientWinArm64Msi.url = url;
            $scope.downloadButton.clientWinArm64Msi.show = true;
            $scope.showKioskIdButton = true;
            $scope.showMsiArgumentsButton = true;
            break;
          case 'CLIENT-MAC-DMG-x64':
            $scope.downloadButton.clientMacDmg.url = url;
            $scope.downloadButton.clientMacDmg.show = true;
            break;
          case 'REDIRECTOR-WIN-EXE-x64':
            $scope.downloadButton.redirectorWinX64.url = url;
            $scope.downloadButton.redirectorWinX64.show = true;
            break;
          case 'REDIRECTOR-WIN-EXE-arm64':
            $scope.downloadButton.redirectorWinArm64.url = url;
            $scope.downloadButton.redirectorWinArm64.show = true;
            break;
          case 'PPDF-WIN-EXE-x64':
            $scope.downloadButton.powerPdfWin.url = url;
            $scope.downloadButton.powerPdfWin.show = true;
            $scope.showPowerPdfArgumentsButton = true;
            break;
          case 'PPDF-MAC-PKG-x64':
            $scope.downloadButton.powerPdfMac.url = url;
            $scope.downloadButton.powerPdfMac.show = true;
            break;
        }
      }

      function mapSoftwareResources() {
        $scope.softwareResourcesAsObjects = {};
        $scope.softwareResources.forEach(software => {
          $scope.softwareResourcesAsObjects[software.appl + '_' + software.os] = software;
        });
      }

      function setCanon() {
        // Need data provided from the back-end service.
        $scope.canon = $scope.softwareResources.find(item => item.os === 'CANON_MEAP' && item.appl === 'DEVICE');
      }

      function setKyocera() {
        $scope.kyocera = $scope.softwareResources.find(item => item.os === 'KYOCERA');
        const fileName = $scope.kyocera?.files[0]?.path;
        const fileExtension = getFileExtension(fileName);
        $scope.kyoceraFileType = fileExtension ? '(' + fileExtension.toUpperCase() + ')' : '';
      }

      function setLexmark() {
        // Need data provided from the back-end service.
        $scope.lexmark = $scope.softwareResources.find(item => item.os === 'LEXMARK' && item.appl === 'DEVICE');
        const fileName = $scope.lexmark?.files[0]?.path;
        const fileExtension = getFileExtension(fileName);
        $scope.lexmarkFileType = fileExtension ? '(' + fileExtension.toUpperCase() + ')' : '';
      }

      function setRicoh() {
        $http.get('https://assets.printix.net/ricohInstaller/WindowsVersion.json')
          .then(function (response) {
            $scope.ricohInstaller = response.data;
          })
          .catch(function () {
          });
        $scope.ricoh = $scope.softwareResources.find(item => item.os === 'RICOH' && item.appl === 'DEVICE');
      }

      function setPowerBi() {
        $scope.powerbi = $scope.softwareResources.find((item) => {
          return item.os === 'POWERBI';
        });
        const fileName = $scope.powerbi?.files[0]?.path;
        const fileExtension = getFileExtension(fileName);
        $scope.powerbiFileType = fileExtension ? '(' + fileExtension.toUpperCase() + ')' : '';
      }

      function setWinDeviceInstallerCli() {
        $scope.winDeviceInstallerCli = $scope.softwareResources.find(item => item.os === 'WIN' && item.appl === 'DEVICE_INSTALLER_CLI');
      }

      function getFileExtension(fileName) {
        if (fileName) {
          const lastDotIndex = fileName.lastIndexOf('.');
          if (lastDotIndex !== -1) {
            const fileExtension = fileName.substring(lastDotIndex + 1);
            if (fileExtension) {
              return fileExtension;
            }
          }
        }
        return undefined;
      }

      function classifyCaptureConnectorFiles() {
        $scope.softwareResources.filter(software => software.appl === 'DESTINATION_CONNECTOR_NETWORKSHARE')
          .forEach(software => {
            software.binFile = software.files.find(file => !file.path.includes('Source'));
            software.srcFile = software.files.find(file => file.path.includes('Source'));
          });
      }

      function loadSoftwareVersions() {
        SoftwareService.getVersionsOfDesktopApplications()
          .then(function (softwareVersions) {
            $scope.softwareVersions = softwareVersions;
            setupDesktopDownloadButtons(softwareVersions);
          })
          .catch(function () {
          });
      }

      function setupDesktopDownloadButtons(softwareVersions) {
        if (!softwareVersions || !softwareVersions.applications) {
          return;
        }
        softwareVersions.applications.forEach(function (application) {
          const files = application?.availableVersions[0]?.files;
          if (files) {
            files.forEach(function (file) {
              enableDownloadButton(application.appType, application.os, file.type, file.cpuArch, file.path);
            });
          }
        });
      }

    });
})();
